import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RouteParameter } from '@biletix/core/common/constants/route-parameter.const';
import { LanguageGuard } from '@biletix/core/guards/language.guard';
import { AuthenticationGuard } from '@biletix/core/guards/authentication.guard';
import { RegionGuard } from '@biletix/core/guards/region.guard';
import { AnonymousGuard } from '@biletix/core/guards/anonymous.guard';
import { SecondaryLayoutComponent } from './core/layouts/secondary-layout/secondary-layout.component';
import { MainLayoutComponent } from './core/layouts/main-layout/main-layout.component';
import { ShoppingCartGuard } from '@biletix/core/guards/shopping-cart.guard';
import { SetLoadingConfigGuard } from '@biletix/core/components/loading/set-loading-config.guard';
import { PageNotFoundComponent } from '@biletix/core/components/page-not-found/page-not-found.component';
import { TranslationResolver } from './core/resolvers/translation.resolver';
import { LoggedInCustomerResolver } from './core/resolvers/logged-in-customer.resolver';
import { EventAnonimUserProtectGuard } from './core/guards/event-anonim-user-protect-guard';
import { RecaptchaResolver } from "@biletix/core/resolvers/recaptcha.resolver";
import { WideLayoutComponent } from './core/layouts/wide-layout/wide-layout.component';
import { ActuatorComponent } from './features/actuator/actuator.component';


const routes: Routes = [
  //MAIN ROUTE
  {
    path: '',
    component: MainLayoutComponent,
    resolve: [LoggedInCustomerResolver],
    children: [
      {
        path: 'home',
        redirectTo: '/home/TURKIYE/tr',
        //redirectTo: '/home',
        pathMatch: 'full',
      },
      {
        path: '',
        redirectTo: '/home/TURKIYE/tr',
        //redirectTo: '/list',
        pathMatch: 'full',
      },
      {
        path: `list/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}`,
        pathMatch: 'full',
        loadChildren: () =>
          import('./features/list/list.module').then((m) => m.ListModule),
        data: {
          loadingConfig: { icon: 'default.svg' },
        },
        resolve: [TranslationResolver],
        canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
      },
      {
        path: `home/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}`,
        pathMatch: 'full',
        loadChildren: () =>
          import('./features/home/home.module').then((m) => m.HomeModule),
        data: {
          loadingConfig: { icon: 'default.svg' },
        },
        resolve: [TranslationResolver],
        canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
      },
      {
        path: `etkinlik-grup/:${RouteParameter.PARAMS.EVENT_GROUP_CODE}/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}/:${RouteParameter.PARAMS.SLUG}`,
        pathMatch: 'full',
        data: {
          loadingConfig: { icon: 'ticket.svg' },
        },
        resolve: [TranslationResolver],
        canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
        loadChildren: () =>
          import('./features/event-group/event-group.module').then(
            (m) => m.EventGroupModule
          ),
      },
      {
        path: `etkinlik-grup/:${RouteParameter.PARAMS.EVENT_GROUP_CODE}/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}`,
        pathMatch: 'full',
        data: {
          loadingConfig: { icon: 'ticket.svg' },
        },
        resolve: [TranslationResolver],
        canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
        loadChildren: () =>
          import('./features/event-group/event-group.module').then(
            (m) => m.EventGroupModule
          ),
      },
      {
        path: `etkinlik-paket-grup/:${RouteParameter.PARAMS.EVENT_PACKAGE_GROUP_CODE}/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}`,
        pathMatch: 'full',
        data: {
          loadingConfig: { icon: 'ticket.svg' },
        },
        resolve: [TranslationResolver],
        canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
        loadChildren: () =>
          import(
            './features/event-package-group/event-package-group.module'
          ).then((m) => m.EventPackageGroupModule),
      },
      {
        path: `etkinlik-paket-detay/:${RouteParameter.PARAMS.EVENT_PACKAGE_DETAIL_CODE}/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}`,
        pathMatch: 'full',
        data: {
          loadingConfig: { icon: 'ticket.svg' },
        },
        resolve: [TranslationResolver],
        canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
        loadChildren: () =>
          import(
            './features/event-package-detail/event-package-detail.module'
          ).then((m) => m.EventPackageDetailModule),
      },
      {
        path: `etkinlik-paket-grup/:${RouteParameter.PARAMS.EVENT_PACKAGE_GROUP_CODE}/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}`,
        pathMatch: 'full',
        data: {
          loadingConfig: { icon: 'ticket.svg' },
        },
        resolve: [TranslationResolver],
        canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
        loadChildren: () =>
          import(
            './features/event-package-group/event-package-group.module'
          ).then((m) => m.EventPackageGroupModule),
      },
      {
        path: `etkinlik-paket-detay/:${RouteParameter.PARAMS.EVENT_PACKAGE_DETAIL_CODE}/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}`,
        pathMatch: 'full',
        data: {
          loadingConfig: { icon: 'ticket.svg' },
        },
        resolve: [TranslationResolver],
        canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
        loadChildren: () =>
          import(
            './features/event-package-detail/event-package-detail.module'
          ).then((m) => m.EventPackageDetailModule),
      },
      {
        path: `etkinlik/:${RouteParameter.PARAMS.EVENT_CODE}/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}/:${RouteParameter.PARAMS.SLUG}`,
        pathMatch: 'full',
        data: {
          loadingConfig: { icon: 'ticket.svg' },
        },
        resolve: [TranslationResolver],
        canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
        loadChildren: () =>
          import('./features/event/event.module').then((m) => m.EventModule),
      },
      {
        path: `etkinlik/:${RouteParameter.PARAMS.EVENT_CODE}/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}`,
        pathMatch: 'full',
        data: {
          loadingConfig: { icon: 'ticket.svg' },
        },
        resolve: [TranslationResolver],
        canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
        loadChildren: () =>
          import('./features/event/event.module').then((m) => m.EventModule),
      },
      {
        path: `performance/:${RouteParameter.PARAMS.EVENT_CODE}/:${RouteParameter.PARAMS.PERF_CODE}/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}/:${RouteParameter.PARAMS.SLUG}`,
        pathMatch: 'full',
        resolve: [TranslationResolver, RecaptchaResolver],
        canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
        data: {
          loadingConfig: { icon: 'ticket.svg' },
        },
        loadChildren: () =>
          import('./features/performance/performance.module').then(
            (m) => m.PerformanceModule
          ),
      },
      {
        path: `performance/:${RouteParameter.PARAMS.EVENT_CODE}/:${RouteParameter.PARAMS.PERF_CODE}/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}`,
        pathMatch: 'full',
        resolve: [TranslationResolver, RecaptchaResolver],
        canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
        data: {
          loadingConfig: { icon: 'ticket.svg' },
        },
        loadChildren: () =>
          import('./features/performance/performance.module').then(
            (m) => m.PerformanceModule
          ),
      },

      {
        path: `cart/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}`,
        pathMatch: 'full',
        data: {
          loadingConfig: { icon: 'cart.svg' },
        },
        resolve: [TranslationResolver],
        canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
        loadChildren: () =>
          import('./features/cart/cart.module').then((m) => m.CartModule),
      },



      {
        path: `myaccount/:${RouteParameter.PARAMS.LANGUAGE}`,
        data: {
          loadingConfig: { icon: 'default.svg' },
        },
        resolve: [TranslationResolver],
        canActivate: [
          SetLoadingConfigGuard,
          AuthenticationGuard,
          LanguageGuard,
          AnonymousGuard,
        ],
        loadChildren: () =>
          import('./features/account/account.module').then(
            (m) => m.AccountModule
          ),
      },
      {
        path: `t/:${RouteParameter.PARAMS.SCODE}/:${RouteParameter.PARAMS.REFCODE}/:${RouteParameter.PARAMS.LANGUAGE}`,
        data: {
        },
        resolve: [TranslationResolver],
        //component:TicketLandingComponent,
        canActivate: [SetLoadingConfigGuard, LanguageGuard],
        loadChildren: () => import('./features/ticket-landing/ticket-landing.module').then(m => m.TicketLandingModule)
      },

      {
        path: `t/:${RouteParameter.PARAMS.SCODE}/:${RouteParameter.PARAMS.REFCODE}`,
        data: {
        },
        resolve: [TranslationResolver],
        //component:TicketLandingComponent,
        canActivate: [SetLoadingConfigGuard, LanguageGuard],
        loadChildren: () => import('./features/ticket-landing/ticket-landing.module').then(m => m.TicketLandingModule)
      },
      {
        path: `rsv/:${RouteParameter.PARAMS.TOKEN}`,
        redirectTo: `rsv/:${RouteParameter.PARAMS.TOKEN}/tr`,
        //redirectTo: '/home',
        pathMatch: 'full',
      },

      {

        path: `rsv/:${RouteParameter.PARAMS.TOKEN}/:${RouteParameter.PARAMS.LANGUAGE}`,
        data: {

        },
        resolve: [TranslationResolver],
        canActivate: [SetLoadingConfigGuard, LanguageGuard],
        loadChildren: () => import('./features/reservation/reservation.module').then(m => m.ReservationModule)
      },
      {
        path: `search/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}`,
        data: { loadingConfig: { icon: 'default.svg' } },
        resolve: [TranslationResolver],
        canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
        loadChildren: () =>
          import('./features/search/search.module').then((m) => m.SearchModule),
      },
      {
        path: `hediyekart/:${RouteParameter.PARAMS.LANGUAGE}`,
        resolve: [TranslationResolver, RecaptchaResolver],
        //component: GiftCardComponent,
        canActivate: [SetLoadingConfigGuard, LanguageGuard],
        loadChildren: () =>
          import('./features/gift-card/gift-card-module').then((m) => m.GiftCardModule),
      },
    ],
  },

  {
    path: `auth/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}`,
    // component: AuthLayoutComponent,
    data: {
      loadingConfig: { icon: 'default.svg' },
    },
    resolve: [TranslationResolver],
    canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
    loadChildren: () =>
      import('@biletix/features/auth/auth.module').then((m) => m.AuthModule),
  },

  {
    path: `sctx/ykb-campaign/:${RouteParameter.PARAMS.LANGUAGE}`,
    component: SecondaryLayoutComponent,
    data: {
      loadingConfig: { icon: 'default.svg' },
    },
    resolve: [TranslationResolver],
    canActivate: [SetLoadingConfigGuard, LanguageGuard],
    loadChildren: () =>
      import('./features/ykb/ykb.module').then((m) => m.YkbModule),
  },
  {
    path: `sctx/ykb-birlikte-daha-guzel/:${RouteParameter.PARAMS.LANGUAGE}`,
    component: SecondaryLayoutComponent,
    data: {
      loadingConfig: { icon: 'default.svg' },
    },
    resolve: [TranslationResolver],
    canActivate: [SetLoadingConfigGuard, LanguageGuard],
    loadChildren: () =>
      import('./features/ykb-august/ykb.module').then((m) => m.YkbModule),
  },

  {
    path: `favorites/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}`,
    pathMatch: 'full',
    data: {
      loadingConfig: { icon: 'default.svg' },
    },
    resolve: [TranslationResolver],
    canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
    loadChildren: () =>
      import('./features/favorites/favorites.module').then((m) => m.FavoritesModule),
  },
  {
    path: `mekan/:${RouteParameter.PARAMS.VENUE_CODE}/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}/:${RouteParameter.PARAMS.SLUG}`,
    component: WideLayoutComponent,
    pathMatch: 'full',
    data: {
      loadingConfig: { icon: 'ticket.svg' },
    },
    resolve: [TranslationResolver],
    canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
    loadChildren: () =>
      import('./features/venue/venue.module').then((m) => m.VenueModule),
  },
  {
    path: `mekan/:${RouteParameter.PARAMS.VENUE_CODE}/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}`,
    component: WideLayoutComponent,
    pathMatch: 'full',
    data: {
      loadingConfig: { icon: 'ticket.svg' },
    },
    resolve: [TranslationResolver],
    canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
    loadChildren: () =>
      import('./features/venue/venue.module').then((m) => m.VenueModule),
  },

  {
    path: `category/:${RouteParameter.PARAMS.CATEGORY_CODE}/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}`,
    component: WideLayoutComponent,
    pathMatch: 'full',
    data: {
      loadingConfig: { icon: 'default.svg' },
    },
    resolve: [TranslationResolver],
    canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
    loadChildren: () =>
      import('./features/category/category.module').then((m) => m.CategoryModule),
  },

  {
    path: `fan-guide/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}`,
    component: WideLayoutComponent,
    pathMatch: 'full',
    data: {
      loadingConfig: { icon: 'default.svg' },
    },
    resolve: [TranslationResolver],
    canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
    loadChildren: () =>
      import('./features/fan-guide/fan-guide.module').then((m) => m.FanGuideModule),
  },
  {
    path: `football/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}`,
    component: WideLayoutComponent,
    pathMatch: 'full',
    data: {
      loadingConfig: { icon: 'default.svg' },
    },
    resolve: [TranslationResolver],
    canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
    loadChildren: () =>
      import('./features/football/football.module').then((m) => m.FootballModule),
  },

  {
    path: `artist/:${RouteParameter.PARAMS.ARTIST_CODE}/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}`,
    component: WideLayoutComponent,
    pathMatch: 'full',
    data: {
      loadingConfig: { icon: 'ticket.svg' }
    },
    resolve: [TranslationResolver],
    canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
    loadChildren: () => import('./features/artist/artist.module').then(m => m.ArtistModule)
  },

  {
    path: `artist/:${RouteParameter.PARAMS.ARTIST_CODE}/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}/:${RouteParameter.PARAMS.SLUG}`,
    component: WideLayoutComponent,
    pathMatch: 'full',
    data: {
      loadingConfig: { icon: 'ticket.svg' }
    },
    resolve: [TranslationResolver],
    canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
    loadChildren: () => import('./features/artist/artist.module').then(m => m.ArtistModule)
  },

  {
    path: `artist-list/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}`,
    component: WideLayoutComponent,
    pathMatch: 'full',
    data: {
      loadingConfig: { icon: 'ticket.svg' }
    },
    resolve: [TranslationResolver],
    canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
    loadChildren: () => import('./features/artist/artist-list/artist-list.module').then(m => m.ArtistListModule)
  },

  {
    path: `anasayfa/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}`,
    component: WideLayoutComponent,
    pathMatch: 'full',
    loadChildren: () =>
      import('./features/homepage/homepage.module').then((m) => m.HomepageModule),
    data: {
      loadingConfig: { icon: 'default.svg' },
    },
    resolve: [TranslationResolver],
    canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
  },



  {
    path: `tmawards/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}`,
    pathMatch: 'full',
    component: MainLayoutComponent,
    data: {
      loadingConfig: { icon: 'default.svg' },
    },
    resolve: [TranslationResolver],
    canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
    loadChildren: () =>
      import('./features/survey/survey.module').then((m) => m.SurveyModule),
  },

  {
    path: `kvkk/:${RouteParameter.PARAMS.REGION}/:${RouteParameter.PARAMS.LANGUAGE}`,
    pathMatch: 'full',
    component: MainLayoutComponent,
    data: {
      loadingConfig: { icon: 'default.svg' },
    },
    resolve: [TranslationResolver],
    canActivate: [SetLoadingConfigGuard, LanguageGuard, RegionGuard],
    loadChildren: () =>
      import('./features/kvkk/kvkk.module').then((m) => m.KvkkModule),
  },


  /**
   *
   */
  {
    path: 'newsales',
    resolve: [TranslationResolver],
    data: {
      showLoginAsAnonymousBtn: true,
      loadingConfig: { icon: 'default.svg' },
    },
    canActivate: [
      SetLoadingConfigGuard,
      AuthenticationGuard,
      ShoppingCartGuard,
    ],
    canActivateChild: [AuthenticationGuard, ShoppingCartGuard],
    loadChildren: () =>
      import('@biletix/features/sales/sales.module').then((m) => m.SalesModule),
  },


  {
    path: 'actuator/info',
    component: ActuatorComponent
  },

  /**
   * Redirect to home page when page not found
   *
   * İki yöntem de kullanılabilir.
   */

  // {
  //     path: '**', pathMatch: 'full',
  //     component: PageNotFoundComponent
  // },

  {
    path: '**',
    pathMatch: 'full',
    component: PageNotFoundComponent,
  },
  {
    path: '404.btx',
    component: PageNotFoundComponent,
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      paramsInheritanceStrategy: 'always',
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
